var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 62,
    fill: "none",
    viewBox: "0 0 68 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 45,
    x: 2,
    y: 13,
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    x: 30,
    y: 58,
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    d: "M6 8.554a2 2 0 0 1 2.48-1.942l24 5.928A2 2 0 0 1 34 14.48v39.965a2 2 0 0 1-2.48 1.942l-24-5.928A2 2 0 0 1 6 48.52V8.554Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    d: "M34 54.446a2 2 0 0 0 2.48 1.942l24-5.928A2 2 0 0 0 62 48.52V8.554a2 2 0 0 0-2.48-1.942l-24 5.928A2 2 0 0 0 34 14.48v39.965Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    d: "M34 53.896a2 2 0 0 0 2.826 1.822l19-8.622A2 2 0 0 0 57 45.276V5.603a2 2 0 0 0-2.826-1.822l-19 8.621A2 2 0 0 0 34 14.226v39.671Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#4E4E4E",
    strokeWidth: 3,
    d: "M34 52.866c0 1.672 1.93 2.606 3.241 1.568l13.99-11.075a2 2 0 0 0 .759-1.59l-.4-37.857c-.017-1.632-1.875-2.557-3.188-1.588l-13.59 10.032a2 2 0 0 0-.813 1.61v38.9Zm-5.757-42.3-5-1.254a1 1 0 0 0-1.243.97v12.902a1 1 0 0 0 1.448.894l1.365-.684a1 1 0 0 1 1.197.23l1.241 1.402c.61.689 1.749.257 1.749-.663V11.536a1 1 0 0 0-.757-.97Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4E4E4E",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m38 16.5 9.5-6.5M38 24.5l2.375-1.625M47.5 18l-4.75 3.25M38 32.5l9.5-6.5M38 40.5l5.115-3.5m4.385-3-2.192 1.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon_inventory.26afeb64.svg";
export { ForwardRef as ReactComponent };